import React from 'react';
import { Link } from 'react-router';
import PerformanceBadge from '../Operations/PerformanceBadge';
import { Cell } from '../../shared/components/Table';
import { dateStr } from '../../shared/misc/utils';
import { DashboardItem, Phase } from '../../services/types/Dashboard';
import EsrrBadge from '../Operations/EsrrBadge';
import TaskStatusBadge from './TaskStatusBadge';

const getCells = (filterPhase: Phase | null) => {
  const cells: Cell<DashboardItem>[] = [
    {
      name: 'operationNumber',
      value: (x) => x.operationNumber,
      render: (x, data) => <Link to={`/operations/${data.operationNumber}?from=/`}>{x}</Link>,
      column: 'opNumber',
    },
    { name: 'title', value: (x) => x.title },
    {
      name: 'startDate',
      value: (x) => dateStr(x.startDate),
      css: 'S1',
    },
    {
      name: 'dueDate',
      value: (x) => dateStr(x.dueDate),
      css: 'S1',
    },
    { name: 'stage', value: (x) => x.stage },
    {
      name: 'esrr',
      value: (x) => x.esrr,
      render: (x) => <EsrrBadge text={x} />,
      disable: () => filterPhase === 'Execution',
    },
    {
      name: 'safeguardPerformance',
      value: (x) => x.safeguardPerformance,
      column: 'spRating',
      render: (x) => <PerformanceBadge code={x} />,
      disable: () => filterPhase !== null && filterPhase !== 'Execution',
    },
    {
      name: 'status',
      value: (x) => x.statusText,
      sortDisabled: true,
      render: (x) => <TaskStatusBadge status={x} />,
    },
  ];

  return cells.filter((c) => !c.disable || !c.disable());
};

export default getCells;
